import React, { useState, useEffect } from 'react';
import { useWindowDimensions } from '../utils/hooks';
import { Alert, Card, Typography, Row, Col, Collapse, Empty, Result, message } from 'antd';
import { State, States } from 'sigt';
import TableRIM from './Tables/TableRIM';
import { connect } from 'react-redux';
import { getRimDocuments } from '../services/contributor';
import { getUserData } from '../redux/actions/auth';

const RimDocuments: React.FC<RimDocumentsProps> = ({ thm, auth, getUserData }) => {
  const { width } = useWindowDimensions();
  const [activeKey, setActiveKey] = useState('0');

  const [recaudos, setRecaudos] = useState<DocumentRIM[]>([]);
  const [loading, setLoading] = useState(true);

  const tiposDocumentos = [
    { id: 1, nombre: 'RIF Vigente', obligatorio: true, estado: 'verificado' },
    { id: 2, nombre: 'Cédula del Representante Legal', obligatorio: true },
    { id: 3, nombre: 'Documento de Acta Constitutiva', obligatorio: true },
    { id: 4, nombre: 'Documento de Última Asamblea', obligatorio: true },
    { id: 5, nombre: 'Ficha Catastral', obligatorio: true },
    { id: 6, nombre: 'Conformidad de Uso', obligatorio: true, estado: 'verificado' },
    { id: 7, nombre: 'Permiso de Ingeniería Municipal', obligatorio: false },
    { id: 8, nombre: 'Permiso de Bomberos', obligatorio: true },
  ];
const fetchDocuments = async () => {
    try {
      setLoading(true);
      const response = await getRimDocuments({ id: auth.user?.contribuyente?.id }, auth.token);

      if (response.status === 200) {
        const result = response.data;

        const referenciasUnicas = result
          .map((d) => d.id_registro_municipal)
          .filter((valor, indice, self) => self.indexOf(valor) === indice);

        const rimAgrupados = referenciasUnicas.map((ref) => {
          const docsRimEspecifico = result.filter((d) => d.id_registro_municipal === ref);

          const resultadoMapped = tiposDocumentos.map((tipo) => {
            const aux = docsRimEspecifico.find((rec) => rec.tipo_recaudo == tipo.id);
            return {
              ...tipo,
              ...aux,
              nombre: tipo.nombre,

              estado: aux ? aux.estado : null,
            };
          });

          return {
            referencia_municipal: docsRimEspecifico[0].referencia_municipal,
            denominacion_comercial: docsRimEspecifico[0].denominacion_comercial,
            id_registro_municipal: docsRimEspecifico[0].id_registro_municipal,
            documentos: resultadoMapped,
            verificados: resultadoMapped.filter((d) => d.estado?.toLowerCase() === 'verificado').length,
          };
        });
        setRecaudos(rimAgrupados);
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setRecaudos([]);
      } else {
        console.error('Error cargando documentos:', error);
        message.error('No se pudieron cargar los documentos');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (auth.user?.contribuyente?.id) {
      fetchDocuments();
    }
  }, [auth.user?.contribuyente?.id]);

  const handleDocumentsChange = async () => {
    await fetchDocuments();
    if (auth.token) await getUserData(auth.token);
  };

  if (!auth.user?.contribuyente) {
    return (
      <Card
        style={{ height: '100%' }}
        title='Agregar Soportes del R.I.M.'
        bodyStyle={{ height: 'calc(100% - 88px)', overflowY: 'scroll', overflowX: 'hidden', border: '1px solid #f0f0f0' }}
        headStyle={{ height: 64, backgroundColor: thm.primaryColor, padding: width < 992 ? '0 10px' : '0 20px', color: 'white' }}
      >
        <Result
          status='warning'
          title='Acceso Restringido'
          subTitle='Este modulo es exclusivo para contribuyentes registrados en el sistema.'
        />
      </Card>
    );
  }

  if (!loading && recaudos.length === 0) {
    return (
      <Card
        style={{ height: '100%' }}
        title='Agregar Soportes del R.I.M'
        bodyStyle={{ height: 'calc(100% - 88px)', overflowY: 'scroll', overflowX: 'hidden', border: '1px solid #f0f0f0' }}
        headStyle={{ height: 64, backgroundColor: thm.primaryColor, padding: width < 992 ? '0 10px' : '0 20px', color: 'white' }}
      >
        <Result
          status='info'
          icon={<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={false} />}
          title='Sin Registros Municipales'
          subTitle='Actualmente no posees Referencias Municipales (R.I.M.) asociadas a tu cuenta.'
        />
      </Card>
    );
  }

  return (
    <Card
      style={{ height: '100%' }}
      title='Agregar Soportes del R.I.M'
      bodyStyle={{ height: 'calc(100% - 88px)', overflowY: 'scroll', overflowX: 'hidden', border: '1px solid #f0f0f0' }}
      headStyle={{ height: 64, backgroundColor: thm.primaryColor, padding: width < 992 ? '0 10px' : '0 20px', color: 'white' }}
    >
      <React.Fragment>
        {auth.user.contribuyente.documentosRimCompletos === false && (
          <Alert
            message='Antes de procesar tus trámites o licencias, debes cargar en formato digital todos los documentos solicitados'
            type='warning'
            showIcon
          />
        )}
        <Typography.Title level={4} style={{ fontSize: 16, marginTop: 15 }}>
          Referencias Municipales (R.I.M.)
        </Typography.Title>
        <Row>
          {recaudos.map((r) => (
            <Col key={r.id_registro_municipal} span={24} style={{ marginTop: 20 }}>
              <Collapse accordion activeKey={activeKey} onChange={(c) => setActiveKey(c as string)}>
                <Collapse.Panel
                  header={`${r.referencia_municipal} - ${r.denominacion_comercial}`}
                  key={r.id_registro_municipal}
                  forceRender
                  extra={
                    <span style={{ marginRight: 15, fontWeight: 'bold', color: thm.primaryColor }}>
                      {r.verificados}/{tiposDocumentos.length} documentos verificados
                    </span>
                  }
                >
                  <TableRIM preloadedData={r.documentos} idRim={r.id_registro_municipal} onSuccess={handleDocumentsChange} />
                </Collapse.Panel>
              </Collapse>
            </Col>
          ))}
        </Row>
      </React.Fragment>
    </Card>
  );
};

const mapStateToProps = (state: State) => ({ thm: state.thm, auth: state.auth });

export default connect(mapStateToProps, { getUserData })(RimDocuments);

interface RimDocumentsProps {
  thm: States.ThemeColors;
  auth: States.Auth;
  getUserData: (token: string) => Promise<any>;
}

interface DocumentRIM {
  id_recaudo_rim: number;
  id_registro_municipal: number;
  referencia_municipal: string;
  denominacion_comercial: string;
  tipo_recaudo: number;
  url: string;
  estado: string;
  nombre?: string;
  obligatorio?: boolean;
  verificados: number;
  documentos: DocumentRIM[];
}
